import { Injectable } from '@angular/core';
// import { AppConfiguration } from '@symphony-solo/shared/app-configuration/src';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { RequestHistoryParams } from '../models';


@Injectable()
export class HistoryService {
  constructor(
    private httpService: HttpService,
    ) {}

    public getAccountHistory(body: RequestHistoryParams): Observable<any> {
      return this.httpService.makePost<any, any>("getaccounthistory",  body);
    }
}
